import * as qs from 'qs'
import Vue from 'vue'

export default class BackEnd {
  // url = '157.230.45.72'
  url = '127.0.0.1'
  port = 7476

  SPCInsertData (data, response) {
    const url = 'http://' + this.url + ':' + this.port + '/SPC/insertData'
    const postQuery = { data: encodeURIComponent(JSON.stringify(data)) }
    const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    // eslint-disable-next-line no-undef
    axios.post(url, qs.stringify(postQuery, { arrayFormat: 'brackets' }), config)
      .then(function (res) {
        response(res.data)
      }).catch(function (e) {
        console.log(e)
      // response(null)
      })
  }

  SPCInsertMultiData (data, response) {
    const url = 'http://' + this.url + ':' + this.port + '/SPC/insertMultiData'
    const postQuery = { data: encodeURIComponent(JSON.stringify(data)) }
    const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    // eslint-disable-next-line no-undef
    axios.post(url, qs.stringify(postQuery, { arrayFormat: 'brackets' }), config)
      .then(function (res) {
        response(res.data)
      }).catch(function (e) {
        console.log(e)
      // response(null)
      })
  }

  DBAggregation (query, response) {
    query.subType = 'aggregate'
    this.DB(query, response)
  }

  DBFind (query, response) {
    query.subType = 'find'
    this.DB(query, response)
  }

  DBInsert (query, response) {
    query.subType = 'insert'
    this.DB(query, response)
  }

  DBUpdate (query, response) {
    query.subType = 'update'
    this.DB(query, response)
  }

  DBDelete (query, response) {
    query.subType = 'delete'
    this.DB(query, response)
  }

  DB (query, response) {
    Vue.prototype.$eventBus.$emit('loading', true)
    query.type = 'MongoDB'
    if (typeof query.name === 'undefined') {
      query.name = 'null'
    }
    const url = 'http://' + this.url + ':' + this.port
    const postQuery = { data: encodeURIComponent(JSON.stringify(query)) }
    const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
    // eslint-disable-next-line no-undef
    axios.post(url, qs.stringify(postQuery, { arrayFormat: 'brackets' }), config)
      .then(function (res) {
        Vue.prototype.$eventBus.$emit('loading', false)
        response(res.data)
      }).catch(function (e) {
        Vue.prototype.$eventBus.$emit('loading', false)
        console.log(e)
      // response(null)
      })
  }
}
